/**
 * 埋点事件汉字拼音对照, 用于诸葛IO迁移神策
 *  */
export const eventsMap = { goods_id: 'Goods_id', 付款成功进入: 'FuKuanChengGongJinRu', 原价: 'YuanJia', 大课标题: 'DaKeBiaoTi', 学习进度: 'XueXiJinDu', 学情信息_加载: 'XueQingXinXi_JiaZai', 小课标题: 'XiaoKeBiaoTi', 已报名: 'YiBaoMing', 已有拼团个数: 'YiYouPinTuanGeShu', 成团人数: 'ChengTuanRenShu', 报告状态: 'BaoGaoZhuangTai', 拼团价: 'PinTuanJia', 拼团状态: 'PinTuanZhuangTai', 拼团页面_加载: 'PinTuanYeMian_JiaZai', 拼团页面_按钮_点击: 'PinTuanYeMian_AnNiu_DianJi', 按钮内容: 'AnNiuNeiRong', 支付方式: 'ZhiFuFangShi', 是否已报名: 'ShiFouYiBaoMing', 是否已报满: 'ShiFouYiBaoMan', 是否登录: 'ShiFouDengLu', 来源: 'LaiYuan', 标签: 'BiaoQian', 点击对象: 'DianJiDuiXiang', 点击效果: 'DianJiXiaoGuo', 维度: 'WeiDu', 获取已购买的直播课联报详情: 'HuoQuYiGouMaiDeZhiBoKeLianBaoXiangQing', 获取已购买的面授课联报详情: 'HuoQuYiGouMaiDeMianShouKeLianBaoXiangQing', 订单状态: 'DingDanZhuangTai', 订单金额: 'DingDanJinE', '课程 ID': 'KeChengID', 课程价格: 'KeChengJiaGe', 课程名称: 'KeChengMingCheng', 课程标题: 'KeChengBiaoTi', 课程状态: 'KeChengZhuangTai', 课程详情_去参团_点击: 'KeChengXiangQing_QuCanTuan_DianJi', 课程详情_发起拼团_点击: 'KeChengXiangQing_FaQiPinTuan_DianJi', '质心灵动量_tab 切换_点击': 'ZhiXinLingDongLiang_tabQieHuan_DianJi', 质心灵动量_加载: 'ZhiXinLingDongLiang_JiaZai', 质心灵动量_我的班级_去支付_点击: 'ZhiXinLingDongLiang_WoDeBanJi_QuZhiFu_DianJi', 质心灵动量_我的班级_去登录_点击: 'ZhiXinLingDongLiang_WoDeBanJi_QuDengLu_DianJi', 质心灵动量_我的班级_课程信息_点击: 'ZhiXinLingDongLiang_WoDeBanJi_KeChengXinXi_DianJi', 质心灵动量_立即登录_点击: 'ZhiXinLingDongLiang_LiJiDengLu_DianJi', 质心灵动量_筛选_点击: 'ZhiXinLingDongLiang_ShaiXuan_DianJi', 质心灵动量_退出_点击: 'ZhiXinLingDongLiang_TuiChu_DianJi', 身份: 'ShenFen', 长期班_支付成功页_加载: 'ChangQiBan_ZhiFuChengGongYe_JiaZai', 长期班_支付页面_加载: 'ChangQiBan_ZhiFuYeMian_JiaZai', 长期班_支付页面_去支付_点击: 'ChangQiBan_ZhiFuYeMian_QuZhiFu_DianJi', 长期班_课程详情_分享_点击: 'ChangQiBan_KeChengXiangQing_FenXiang_DianJi', 长期班_课程详情_加载: 'ChangQiBan_KeChengXiangQing_JiaZai', 长期班_课程详情_报名_点击: 'ChangQiBan_KeChengXiangQing_BaoMing_DianJi', 长期班_课程详情_提交学生信息_点击: 'ChangQiBan_KeChengXiangQing_TiJiaoXueShengXinXi_DianJi' }
export const numberValuekey = ['ChengTuanRenShu', 'SuoXuanKeShu',
  'ZongJiaGe',
  'YiYouPinTuanGeShu',
  'TongJiDuiHuanCiShu',
  'KeChengGeShu',
  'CiXu',
  'DaKeJiaGe',
  'ZongHuaFei',
  'KeChengJiaGe',
  'DianJiZongShu',
  'TongJiChaXunChengGongCiShu',
  'JiaGe',
  'TiJieChangDu',
  'LianBaoKeChengGeShu',
  'XiaoKeShuLiang',
  'HuiFuGeShu',
  'HeJiJinE',
  'DingDanJinE',
  'CunHuoShiJian',
  'WoDeTiJiaoShu',
  'TiJiaoCiShu',
  'DingDanJiaGe',
  'JieGuoTiaoShu',
  'JieSuanKeChengGeShu',
  'PinTuanJia',
  'GouKeDanKeChengGeShu',
  'ZhengZaiPinTuanGeShu',
  'YiTiJiaoTiJieShu',
  'KeChengShuLiang',
  'TiJieShuLiang',
  'LiWuGeShu',
  'TiJiePianShu',
  'DeFen',
  'YuanJia',
  'ShiFuJinE',
  'TongJiJinRuDuiHuanMaYeMianCiShu',
  'TaoLunGeShu'
]
